import { render, staticRenderFns } from "./PrSplitVertical.vue?vue&type=template&id=7487a1a8&"
import script from "./PrSplitVertical.vue?vue&type=script&lang=js&"
export * from "./PrSplitVertical.vue?vue&type=script&lang=js&"
import style0 from "./PrSplitVertical.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports